"use strict";
/**
 * 品牌色候选池。
 *
 * ## 为什么色值只允许出现在这个文件里
 *
 * 全仓有一条 lint 规则（`icetus/no-raw-color`）禁止裸色值，只有 `tokens/`
 * 目录下的文件例外 —— 因为颜色令牌本来就得有个地方定义。这个文件就是那个
 * 例外点，**它是令牌，不是样式**。
 *
 * ## 为什么给候选而不是让模型自由取值
 *
 * 模型自由给的 hex 经常是 `#FF5722` 这类高饱和色：压在深色页头上一片焦，
 * 做成按钮又显得廉价。所以提示词里只给它这六个，让它**选**而不是**取值**；
 * 选完再用 `contrast.ts` 校一遍与白字的对比度，不达 4.5:1 就压明度。
 *
 * 六个都刻意压低了饱和度 —— 它们要压在两套底色（浅色的极光/子午线、
 * 深色的窑变）上都能看，而不是只在屏幕上鲜艳。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_BRAND_COLOR = exports.BRAND_PALETTE_LIST = exports.BRAND_PALETTES = void 0;
exports.acceptBrandColor = acceptBrandColor;
exports.brandPalettePrompt = brandPalettePrompt;
exports.BRAND_PALETTES = {
    steel: { hex: '#1F3A5F', name: 'deep steel blue' },
    sienna: { hex: '#8C3A1E', name: 'burnt sienna' },
    forest: { hex: '#2E5B3E', name: 'deep forest green' },
    charcoal: { hex: '#3F3F46', name: 'charcoal' },
    aubergine: { hex: '#4A3B52', name: 'muted aubergine' },
    teal: { hex: '#1E4E4A', name: 'dark teal' },
    stone: { hex: '#5A5148', name: 'warm stone' },
    clay: { hex: '#B4632A', name: 'fired clay' },
    slate: { hex: '#233746', name: 'slate navy' },
};
exports.BRAND_PALETTE_LIST = Object.values(exports.BRAND_PALETTES);
/** 兜底色：深钢蓝。所有行业都能用，压白字对比度也够 */
exports.DEFAULT_BRAND_COLOR = exports.BRAND_PALETTES.steel.hex;
/** 只接受候选里的那几个 —— 不信任模型"顺手"给的其它 hex */
function acceptBrandColor(value) {
    const text = typeof value === 'string' ? value.trim().toUpperCase() : '';
    const hit = exports.BRAND_PALETTE_LIST.find((entry) => entry.hex.toUpperCase() === text);
    return hit ? hit.hex : exports.DEFAULT_BRAND_COLOR;
}
/** 拼进提示词的那一句：`#1F3A5F (deep steel blue), ...` */
function brandPalettePrompt() {
    return exports.BRAND_PALETTE_LIST.map((entry) => `${entry.hex} (${entry.name})`).join(', ');
}
//# sourceMappingURL=brand-palette.js.map